document.addEventListener("DOMContentLoaded", () => {
  const dialogs = document.querySelectorAll("dialog");

  dialogs.forEach((dialog, index) => {
    // Asignar un ID único si no tiene uno
    if (!dialog.id) {
      dialog.id = 'dialog-' + index;
    }

    const showButton = dialog.nextElementSibling; // Botón adyacente
    const closeButton = dialog.querySelector("button");
    const dialogId = dialog.id;

    // Mostrar el diálogo (sin guardar estado ni modificar historial)
    showButton.addEventListener("click", () => {
      dialog.showModal();
      document.body.style.overflow = 'hidden';
      // Se eliminaron las líneas que guardaban el estado en sessionStorage
      // y modificaban el historial del navegador
    });

    // Cerrar el diálogo (sin limpiar estado ni modificar historial)
    closeButton.addEventListener("click", () => {
      dialog.close();
      document.body.style.overflow = 'auto';
      // Se eliminaron las líneas que limpiaban el estado en sessionStorage
      // y modificaban el historial del navegador
    });

    // Cerrar el diálogo al hacer clic en el backdrop
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog && dialog.open) {
        dialog.close();
        document.body.style.overflow = 'auto';
        // Se eliminaron las líneas que limpiaban el estado en sessionStorage
        // y modificaban el historial del navegador
      }
    });
  });

  // Se eliminó el código que reabre el diálogo al cargar la página

  // Se eliminó el event listener para 'popstate'
});